import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { useLocale } from '@gov-nx/core/service';
import { PageCode, useMojeAutorizaceSeznamContext } from '@gov-nx/module/page';
import {
	FormSearch,
	FormWidthElementLayout,
	HeaderLayout,
} from '@gov-nx/ui/web';

export const MyAuthorizationsListFilter = () => {
	const { onSubmit, filterForm } = useMojeAutorizaceSeznamContext();
	const { t } = useLocale(PageCode['moje-podani']);

	return (
		<GovFormWeb
			formDefinition={{ ...filterForm }}
			onSubmit={onSubmit}>
			<HeaderLayout>
				<FormWidthElementLayout
					type="l"
					className="relative">
					<FormSearch
						input={{
							field: {
								name: 'text',
								placeholder: t('filtr.placeholder.vyhledat-autorizaci'),
							},
							label: { children: t('filtr.pole.wcag.vyhledat-autorizaci') },
						}}
						button={{
							'aria-label': t('akce.wcag.vyhledat'),
						}}
					/>
				</FormWidthElementLayout>
			</HeaderLayout>
		</GovFormWeb>
	);
};
